import { Stack } from '@mui/material';
import { Control } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { BasicDatePicker } from './BasicDatePicker';
import { PickerValue } from '@mui/x-date-pickers/internals';
import { DayJsRange } from '@shared/entity';

type DateRangeVisitFiltersProps = {
  control: Control<Partial<DayJsRange>>;
  onChangeTo: (date: PickerValue) => void;
  onChangeFrom: (date: PickerValue) => void;
};

const DateRangeFilters = ({ control, onChangeTo, onChangeFrom }: DateRangeVisitFiltersProps) => {
  const intl = useIntl();

  return (
    <Stack direction="row" spacing={2}>
      <BasicDatePicker
        label={intl.formatMessage({
          defaultMessage: 'Datum od',
          id: 'dateFrom',
        })}
        control={control}
        fieldPath="from"
        onChange={onChangeFrom}
      />
      <BasicDatePicker
        label={intl.formatMessage({
          defaultMessage: 'Datum do',
          id: 'dateTo',
        })}
        control={control}
        fieldPath="to"
        onChange={onChangeTo}
      />
    </Stack>
  );
};

export default DateRangeFilters;
